import Vue from 'vue';
export default Vue.extend({
    name: 'linearPlot',
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    computed: {
        getPlotWidth() {
            return (item) => Number(item.value) / Number(this.items[0].value) * 100 + '%';
        }
    }
});
